<template>
  <div class="outer-wrapper">
    <div class="button-wrapper">
      <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
        >打印</Button
      >
    </div>
    <div id="to_single_print">
    <div class="content" >
      <div class="inner">
        <p class="table-no">表号：{{ value.formNo }}</p>
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">磁粉检测报告</p>
        <p class="sn" @click="alterInputClick('reportNo','报告编号')">
          报告编号：<span>{{ value.reportNo }}</span>
        </p>
        <table class="p1">
          <tr>
            <td width="12%"><p>检件名称</p></td>
            <td width="13%">
              <p>{{ value.name }}</p>
            </td>
            <td width="12%"><p>检件批号</p></td>
            <td width="13%">
              <p class="cell-p">{{ value.batchNo }}</p>
            </td>
            <td width="13%"><p>检件材质</p></td>
            <td width="12%">
              <p>{{ value.grade }}</p>
            </td>
            <td width="13%"><p>热处理状况</p></td>
            <td width="12%">
              <p>{{ value.heatType }}</p>
            </td>
          </tr>
          <tr>
            <td><p>检测标准</p></td>
            <td colspan="3">
              <p>{{ value.standard }}</p>
            </td>
            <td><p>验收等级</p></td>
            <td>
              <p>{{ value.acceptLevel }}</p>
            </td>
            <td><p>检测比例</p></td>
            <td>
              <p>{{ value.inspectRatio }}</p>
            </td>
          </tr>
          <tr>
            <td><p>仪器型号</p></td>
            <td>
              <p>{{ value.equipmentModel }}</p>
            </td>
            <td><p>仪器编号</p></td>
            <td>
              <p>{{ value.equipmentNum }}</p>
            </td>
            <td><p>提升力</p></td>
            <td>
              <p>{{ value.liftingPower }}</p>
            </td>
            <td><p>最大极距</p></td>
            <td>
              <p>{{ value.maxDistance }}</p>
            </td>
          </tr>
          <tr>
            <td><p>磁悬液浓度</p></td>
            <td>
              <p>{{ value.magneticParticlePotency }}</p>
            </td>
            <td><p>磁粉类型</p></td>
            <td>
              <p>{{ value.magneticParticleModel }}</p>
            </td>
            <td><p>载 液</p></td>
            <td>
              <p>{{ value.magneticParticleLiquid }}</p>
            </td>
            <td><p>磁悬液施加方法</p></td>
            <td>
              <p>{{ value.magneticParticleMethod }}</p>
            </td>
          </tr>
          <tr>
            <td><p>表面状态</p></td>
            <td>
              <p>{{ value.surfaceStat }}</p>
            </td>
            <td><p>可见光照度</p></td>
            <td>
              <p>{{ value.illuminance }}</p>
            </td>
            <td><p>灵敏度试片</p></td>
            <td colspan="3">
              <p>{{ value.audition }}</p>
            </td>
          </tr>
          <tr>
            <td><p>检测方法</p></td>
            <td colspan="3">
              <p>{{ value.testMethod }}</p>
            </td>
            <td><p>磁化方法</p></td>
            <td>
              <p>{{ value.magnetizationMode }}</p>
            </td>
            <td><p>磁化时间</p></td>
            <td>
              <p>{{ value.magnetizationDuration }}</p>
            </td>
          </tr>
          <tr>
            <td><p>工艺卡编号</p></td>
            <td colspan="3">
              <p>{{ value.processCard }}</p>
            </td>
            <td><p>原始记录编号</p></td>
            <td colspan="3">
              <p>{{ value.recordNo }}</p>
            </td>
          </tr>
        </table>
        <div class="p2">
          <p class="sign-title">检测部位示意图说明：</p>
          <img :src="img1" alt="" style="height:150pt;"/>
        </div>
        <div class="p3">
          <p class="sign-title">检测结论：</p>
          <p class="result">
            检测部位符合{{ value.standard }} 标准中的
            <b style="text-decoration: underline">{{ value.acceptLevel }}</b>
            要求，评定为
            <b style="text-decoration: underline">合格</b>
            。
          </p>
        </div>
        <table class="p4">
          <tr>
            <td width="23%">
              <p class="sign-title" @click="alterSelectClick('sign1','检测签名')">检测：<span class="sign-img" v-show="value.sign1"><img :src="urlTrans(value.sign1)" alt="" style="width:90pt;height:34pt;"></span></p>
              
              <p class="sign-mark">MT-Ⅱ</p>
            </td>
            <td width="23%">
              <p class="sign-title" @click="alterSelectClick('sign2','审核签名')">审核：<span class="sign-img" v-show="value.sign2"><img :src="urlTrans(value.sign2)" alt="" style="width:90pt;height:34pt;"></span></p>
              <p class="sign-mark">MT-Ⅱ</p>
            </td>
            <td width="34%">
              <p class="sign-title">无损检测专用章：</p>
              <p class="sign-mark">日期：{{ value.reportDate }}</p>
            </td>
          </tr>
        </table>
        <p class="page">第1页 共{{value.pronumList.length+1}}页</p>
      </div>
    </div>
    <div
      class="content"
      v-for="(sublist, i) in value.pronumList"
      :key="i"
    >
      <div class="inner">
        <p class="table-no">表号：{{ value.formNo }}</p>
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">磁粉检测报告</p>
        <p class="sn">
          报告编号：<span>{{ value.reportNo }}</span>
        </p>
        <table class="p5">
          <tr>
            <td width="10%"><p>序号</p></td>
            <td width="15%"><p>工件编号</p></td>
            <td width="15%"><p>缺陷位置</p></td>
            <td width="15%"><p>缺陷性质</p></td>
            <td width="15%"><p>缺陷长度</p></td>
            <td width="15%"><p>评定结果</p></td>
            <td width="15%"><p>缺陷处理</p></td>
          </tr>
          <tr v-for="index in value.pagerows" :key="index">
            <td>
              <p>{{ index>sublist.length?'':(index+value.pagerows*i) }}</p>
            </td>
            <td>
              <p>{{ index>sublist.length?'':sublist[index-1].pronum }}</p>
            </td>
            <td><p>{{index>sublist.length?'':sublist[index-1].defectPosition}}</p></td>
            <td><p>{{index>sublist.length?'':sublist[index-1].defectType}}</p></td>
            <td><p>{{index>sublist.length?'':sublist[index-1].defectLength}}</p></td>
            <td><p>{{index>sublist.length?'':sublist[index-1].level}}</p></td>
            <td><p>{{index>sublist.length?'':sublist[index-1].defectSolution}}</p></td>
          </tr>
        </table>
        <table class="p6">
          <tr>
            <td width="50%">
              <p class="sign-title">检测：<span class="sign-img" style="margin-left:40pt;" v-show="value.sign1"><img :src="urlTrans(value.sign1)" alt="" style="width:90pt;height:34pt;"></span></p>
              <p class="sign-mark">MT-Ⅱ</p>
            </td>
            <td width="50%">
              <p class="sign-title">审核：<span class="sign-img" style="margin-left:50pt;" v-show="value.sign2"><img :src="urlTrans(value.sign2)" alt="" style="width:90pt;height:34pt;"></span></p>
              <p class="sign-mark">MT-Ⅱ</p>
            </td>
          </tr>
        </table>
        <p class="page">第{{i+2}}页 共{{value.pronumList.length+1}}页</p>
      </div>
    </div>
    </div>

    <Modal v-model="modalValue.alterValue" :width="1000" :mask-closable="false">
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValue')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ fileId }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <input
                  autofocus
                  :type="currentType"
                  placeholder=""
                  v-model="currentValue"
                  style="width: 600px"
                  @keyup.enter="alterSubmit"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValue')">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ fileId }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <select v-model="currentValue">
                  <option
                    :value="item.url"
                    v-for="(item, index) in signatureList"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValueSelect')"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "mtReport",
  props: {
    fileId: {
      type: String,
    },
  },
  components: {},
  created() {
    this.getContent();
    this.getStaticOptionsData();
  },
  data() {
    return {
      value: {},
      pronumList:[],
      printParams: {
        id: "to_single_print",
        popTitle: "",
      },
      fid: 0,
      modalValue: {
        alterValue: false,
        alterValueSelect: false,
      },
      currentValue: "",
      currentKey: "",
      currentText: "",
      currentType: "text",
      signatureList: [],
      img1: process.env.BASE_URL + "img/mt1.jpg",
    };
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "signatureList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.signatureList = response.data.res_record.signatureList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "normalReport",
          enid: this.fileId,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.fid = response.data.fid;
            this.value = response.data.content;
            this.$forceUpdate();
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    alterInputClick(key, text, t = "text") {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.currentType = t;
      this.openModal("alterValue");
    },
    alterSelectClick(key, text) {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.openModal("alterValueSelect");
    },
    alterSubmit() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid: this.fid,
          currentValue: this.currentValue,
          currentKey: this.currentKey,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.closeModal("alterValue");
            this.closeModal("alterValueSelect");
            this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    openModal(label) {
      this.modalValue[label] = true;
    },
    closeModal(label) {
      this.modalValue[label] = false;
    },
    urlTrans(url) {
      return this.$fileUrlFac(url, authData.sfileRight);
    },
  },
  computed: {},
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper {
  padding: 20px;
}
.content {
  height: 840.36pt;
  width: 594.3pt;
  color: #000;
  text-align: center;
  position: relative;
  margin: 1px;
  overflow: hidden;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    margin-bottom: 10px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title {
  font-size: 14pt;
}

.content p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 8pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 5pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}

.cell-p {
  line-height: 14pt !important;
}

.free-text {
  text-align: left;
  padding: 3pt 10pt;
}

.underline {
  display: inline-block;
  width: 80pt;
  border-bottom: 1px solid #333;
  line-height: 14pt;
  text-align: center;
}

.w1 {
  border: 1px solid #333;
  padding: 10pt;
}

.sub-title {
  margin-top: 30pt;
  text-align: center;
  font-size: 16pt !important;
  font-weight: 600;
  margin-bottom: 10pt;
}

.sign {
  margin-top: 10pt;
  text-align: right;
}

.p1,
.p2,
.p3,
.w1,
.p4,
.p5 {
  border: 1px solid #333;
}

.p1 td {
  padding: 9pt 0;
}

.p1 p {
  line-height: 1.2;
}

.s-line {
  position: relative;
  bottom: 0.5pt;
}

.sign-span {
  margin-right: 100pt;
  position: relative;
}

.sign-img {
  position: absolute;
  left: 20pt;
  top: 10pt;
  z-index: 10;
}

.sign-item {
  position: absolute;
  left: 50pt;
  white-space: nowrap;
}

.date-span {
  margin-right: 60pt;
  position: relative;
}

.date-item {
  position: absolute;
  left: 30pt;
  white-space: nowrap;
}

.inner-content-wrapper {
  margin: 0 auto;
  width: fit-content;
}

table.base td {
  border: none;
}

input {
  border: none;
  outline: none;
  border-bottom: 1px solid #666;
  text-align: center;
  padding: 3pt 5pt;
}

div.p2 {
  padding: 15pt 10pt;
}

.p2 p,
.p3 p {
  font-size: 11pt;
}


div.p3{
  padding: 15pt 10pt;
}


.sign-title {
  text-align: left;position: relative;
}

.sign-mark {
  text-align: right;
}

.result {
  text-align: left;
  text-indent: 24pt;
}

table.p5 td {
  padding: 0pt 0;
  height:24pt;
}

.page {
  text-align: right;
  color: #999;
  padding-top: 5pt;
  padding-right: 5pt;
}
</style>